module.exports = __webpack_public_path__ + "static/media/aman_logo.7dd0a85e.png";